import React from 'react'
import UiContentCard from "../../../components/cards/UiContentCard"
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import London from "../../../../../styles/img/favourites/london.jpg"
import Nike from "../../../../../styles/img/favourites/nike.jpg"
import Tokyo from "../../../../../styles/img/favourites/tokyo.jpg"
import { UiButtonOutline } from "../../../components/form/UiButton"

export default function ProductsList(props) {

    const readMore = () => {
    }
    return (
        <>
         <div className='sb-products-list-wr'>
            <UiSingleRow>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        rating="4.41"
                        reviews="47"
                        heading="Nike"
                        footer="true"
                        bottomIcon="true"
                        body="From its medieval origins to the digital era, learn from its everything."
                        readMore={readMore}
                        points="35K"
                        savings="25K"
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        rating="4.41"
                        reviews="47"
                        heading="Nike"
                        footer="true"
                        bottomIcon="true"
                        body="From its medieval origins to the digital era, learn from its everything."
                        readMore={readMore}
                        points="35K"
                        savings="25K"
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        rating="4.41"
                        reviews="47"
                        heading="Nike"
                        footer="true"
                        bottomIcon="true"
                        body="From its medieval origins to the digital era, learn from its everything."
                        readMore={readMore}
                        points="35K"
                        savings="25K"
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        rating="4.41"
                        reviews="47"
                        heading="Nike"
                        footer="true"
                        bottomIcon="true"
                        body="From its medieval origins to the digital era, learn from its everything."
                        readMore={readMore}
                        points="35K"
                        savings="25K"
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        rating="4.41"
                        reviews="47"
                        heading="Nike"
                        footer="true"
                        bottomIcon="true"
                        body="From its medieval origins to the digital era, learn from its everything."
                        readMore={readMore}
                        points="35K"
                        savings="25K"
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        rating="4.41"
                        reviews="47"
                        heading="Nike"
                        footer="true"
                        bottomIcon="true"
                        body="From its medieval origins to the digital era, learn from its everything."
                        readMore={readMore}
                        points="35K"
                        savings="25K"
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        rating="4.41"
                        reviews="47"
                        heading="Nike"
                        footer="true"
                        bottomIcon="true"
                        body="From its medieval origins to the digital era, learn from its everything."
                        readMore={readMore}
                        points="35K"
                        savings="25K"
                    />
                </UiCol>
                <UiCol lg="3">
                    <UiContentCard
                        cardImg={Nike}
                        rating="4.41"
                        reviews="47"
                        heading="Nike"
                        footer="true"
                        bottomIcon="true"
                        body="From its medieval origins to the digital era, learn from its everything."
                        readMore={readMore}
                        points="35K"
                        savings="25K"
                    />
                </UiCol>
                
                <UiButtonOutline isLoading={true} btnName="View All" />
            </UiSingleRow>
            </div>
        </>
    )
}
